import { useQuery } from '@tanstack/react-query'
import { flagFunctions } from '../../api/modules/flagApi'
import { FlagDefinition } from '../../types/agentTypes'

export const FLAGS_QUERY_KEY = ['flags'] as const

/**
 * The active flag classifiers, from `GET /api/flags/`. Mirrors
 * {@link useVisibleKnowledgeSites} (react-query, generous `staleTime`) —
 * definitions only change on a deploy or an admin edit.
 */
export function useFlags(enabled = true) {
  const { data: flags = [], isLoading } = useQuery<FlagDefinition[]>({
    queryKey: FLAGS_QUERY_KEY,
    queryFn: () => flagFunctions.fetchFlags(),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    enabled,
  })

  return { flags, isLoading }
}
